import { css } from 'styled-components';

import { rgba } from '@/styles/js/utils/colors';
import { colors } from '@/styles/js/utils/theme';

export const subtleShadow = css`
  box-shadow: 0 2px 5px ${rgba(colors.text, 0.12)};
`;
